export var PageType;
(function (PageType) {
    PageType["HTML"] = "HTML";
    PageType["MailTemplate"] = "MailTemplate";
    PageType["URL"] = "URL";
    PageType["Partner"] = "Partner";
    PageType["Places"] = "Places";
    PageType["Events"] = "Events";
})(PageType || (PageType = {}));
export var PageSlots;
(function (PageSlots) {
    PageSlots["HEADER"] = "header";
    PageSlots["FOOTER"] = "footer";
})(PageSlots || (PageSlots = {}));
export const PageSlotsTranslation = {
    [PageSlots.HEADER]: 'Nagłówek',
    [PageSlots.FOOTER]: 'Stopka'
};
export const PageTypeTranslation = {
    [PageType.HTML]: 'Strona HTML',
    [PageType.MailTemplate]: 'Formularz kontaktowy',
    [PageType.URL]: 'Przekierowanie',
    [PageType.Partner]: 'Moduł Partnerzy',
    [PageType.Places]: 'Moduł Obiekty',
    [PageType.Events]: 'Moduł Usług'
};
//# sourceMappingURL=pageType.enum.js.map